import { createAction, handleActions } from "redux-actions";

const defaultState = {
    message: null,
    dismissed: true
};

export const setError = createAction("SET_ERROR", (message) => ({
    message
}));

export const clearError = createAction("CLEAR_ERROR");

const error = handleActions(
    {
        [setError]: (state, action) => {
            return {
                message: action.payload.message,
                dismissed: false
            };
        },
        [clearError]: () => {
            return defaultState;
        }
    },
    defaultState
);

export default error;
